import { set } from '@ember/object';
import Route from 'mewe/routes/route';

import { Theme } from 'mewe/constants';
import { fetchFeedEvent, getEventFeed } from 'mewe/fetchers/fetch-feed';
import { isDefined } from 'mewe/utils/miscellaneous-utils';
import EventsApi from 'mewe/api/events-api';

export let AppEventFeedRouteBase = {
  theme: Theme.EVENT,

  queryParams: {
    tag: {
      refreshModel: true,
    },
  },

  model(params, transition) {
    let eventId = this.paramsFor('app.event').event_id;
    let { to: toRouteInfo } = transition;

    this.tag = toRouteInfo.queryParams.tag || null;

    fetchFeedEvent(eventId, { hashtag: this.tag });

    EventsApi.markFeedAsSeen(eventId).then(() => {
      let ev = ds.events.for('upcoming-events').items.find((ev) => ev.id === eventId);
      if (ev) set(ev, 'unreadPostsCount', 0);
    });

    return {
      eventId: eventId,
      eventState: this.modelFor('app.event').eventState,
      feed: getEventFeed(eventId),
      app: this.modelFor('app'),
      preventScroll: this.shouldPreventPageScroll(transition),
      tag: this.tag,
    };
  },

  // don't scroll feed when transition from pending posts feed
  shouldPreventPageScroll(transition) {
    const pendingFeedRoute = 'app.event.feed-pending';
    return (
      isDefined(transition.router.oldState && transition.router.oldState.params[pendingFeedRoute]) ||
      this.routeName === pendingFeedRoute
    );
  },

  actions: {
    willTransition(transition) {
      let { to: toRouteInfo } = transition;

      // checking tag stored in 'this' instead controller to avoid some problems (SG-16051)
      if (this.tag) {
        this.controller.set(
          'tag',
          toRouteInfo.queryParams && toRouteInfo.queryParams.tag ? toRouteInfo.queryParams.tag : null
        );
        history.replaceState('', document.title, window.location.pathname); // prevent loading feed for tag on back navigation
      }

      if (toRouteInfo.queryParams && toRouteInfo.queryParams.tag && !this.shouldPreventPageScroll(transition))
        window.scrollTo(0, 400);
    },

    refreshFeed() {
      fetchFeedEvent(this.currentModel.eventId);
    },

    refetchFeed() {
      getEventFeed(this.currentModel.eventId).posts.clear();
      fetchFeedEvent(this.currentModel.eventId);
    },
  },
};

export default Route.extend(AppEventFeedRouteBase);
